var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base64img",style:(`background-image:url(${_vm.Fn.hashToUrl(_vm.url)})`)},[_vm._t("default"),(_vm.showPreview)?_c('previewButton',{attrs:{"url":_vm.url,"noSync":_vm.noSync}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }